import React, { Component, PropTypes } from 'react';
import Icon from './Icon';

export default class Stats extends Icon {
  render() {
    let { color, size, viewPortSize, className, ...props } = this.props;

    return (
      <svg
        width={size}
        height={size}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox={'0 0 ' + viewPortSize + ' ' + viewPortSize}
        {...props}
      >
        <g fill={color}>
          <polygon
            points="14.8,13.5 14.8,1 12.8,1 12.8,13.5 10.9,13.5 10.9,4.2 8.9,4.2 8.9,13.5 7.1,13.5 7.1,7.5 5.1,7.5
          5.1,13.5 3.2,13.5 3.2,6.5 1.2,6.5 1.2,13.5 0,13.5 0,15 16,15 16,13.5 "
          />
        </g>
      </svg>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Icons/Stats.js